(function () {
  'use strict';
 
    function starString(score) {
    var rounded = Math.round(score || 0);

    var filledStar = `
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" aria-hidden="true">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.75048 12.1895L2.41652 9.42956C1.78727 8.92634 2.06326 7.91438 2.86179 7.8003L7.59041 7.58963L9.60974 2.52705C9.75049 2.24646 10.0366 2.06982 10.3503 2.06982C10.664 2.06982 10.9501 2.24738 11.0909 2.52705L13.1102 7.58963L17.8388 7.8003C18.6374 7.91438 18.9134 8.92634 18.2841 9.42956L14.9501 12.1895L15.86 17.5777C15.9649 18.3128 15.2013 18.8629 14.538 18.5308L10.3503 15.8693L6.16263 18.5299C5.49841 18.862 4.73576 18.3118 4.84064 17.5768L5.75048 12.1895Z"
            fill="#ECB018"/>
        </svg>
    `;

    var emptyStar = filledStar.replace('#ECB018', '#b7b6b4');

    return filledStar.repeat(rounded) + emptyStar.repeat(5 - rounded);
    }
 
  function buildCard(review) {
    var card = document.createElement('div');
    card.className = 'reviews-carousel__card';
 
    var img = document.createElement('img');
    img.className = 'reviews-carousel__image';
    img.loading = 'lazy';
    img.alt = review.name || 'Customer photo';
    var photoUrl =
      review.images_data && review.images_data[0] && review.images_data[0].thumb_url;
    if (photoUrl) img.src = photoUrl;
 
    var text = document.createElement('p');
    text.className = 'reviews-carousel__text';
    text.textContent = review.content || '';
 
    var stars = document.createElement('span');
    stars.className = 'reviews-carousel__card-stars';
    stars.innerHTML = starString(review.score);
 
    var name = document.createElement('span');
    name.className = 'reviews-carousel__name';
    name.textContent = review.user ? review.user.display_name : 'Verified Buyer';

    var nameStarHolder = document.createElement('div');
    nameStarHolder.className = 'reviews-carousel__name_wrapper flex md:gap-[14px] gap-[12px] items-center' +
      ' md:min-h-[29px]';

    nameStarHolder.appendChild(stars);
    nameStarHolder.appendChild(name);
 
    if (photoUrl) card.appendChild(img);
    card.appendChild(text);
    card.appendChild(nameStarHolder);
    return card;
  }
 
  // Yotpo's "widget" endpoints (api-cdn.yotpo.com) are public and CORS-
  // enabled — no secret utoken required, safe to call from the browser.
  // Product reviews and site-wide reviews use the same shape, with the
  // special "yotpo_site_reviews" product_id used for the site-wide feed.
  // Docs: https://apidocs.yotpo.com/reference/retrieve-reviews-for-a-product
  //       https://apidocs.yotpo.com/reference/retrieve-widget-site-reviews
  function buildRequestUrl(config) {
    var productId =
      config.scope === 'product' && config.productId ? config.productId : 'yotpo_site_reviews';
 
    return (
      'https://api-cdn.yotpo.com/v1/widget/' +
      config.appKey +
      '/products/' +
      productId +
      '/reviews.json?per_page=' +
      config.perPage +
      '&page=1'
    );
  }
 
  function normalizeReviews(data) {
    if (data && data.response && data.response.reviews) return data.response.reviews;
    if (data && data.reviews) return data.reviews;
    return [];
  }
 
  function normalizeBottomline(data) {
    var bl =
      (data && data.response && data.response.bottomline) ||
      (data && data.bottomline);
    if (!bl) return null;
    return {
      average: bl.average_score,
      total: bl.total_review || bl.total_reviews
    };
  }
 
  function initCarousel(root, config) {
    var track = root.querySelector('[data-reviews-track]');
    var loading = root.querySelector('[data-reviews-loading]');
    var prevBtn = root.querySelector('[data-reviews-prev]');
    var nextBtn = root.querySelector('[data-reviews-next]');
    var summaryStars = root.querySelector('[data-summary-stars]');
    var summaryCount = root.querySelector('[data-summary-count]');
 
    var position = 0;
    var cardWidth = 0;
    var visibleCount = 1;
    var maxPosition = 0;
    var autoplayTimer = null;
 
    function measure() {
      var card = track.querySelector('.reviews-carousel__card');
      if (!card) return;
      var trackStyle = window.getComputedStyle(track);
      var gap = parseFloat(trackStyle.gap || '20');
      cardWidth = card.getBoundingClientRect().width + gap;
      var viewport = root.querySelector('.reviews-carousel__viewport');
      visibleCount = Math.max(1, Math.floor(viewport.getBoundingClientRect().width / cardWidth));
      var totalCards = track.querySelectorAll('.reviews-carousel__card').length;
      maxPosition = Math.max(0, totalCards - visibleCount);
      position = Math.min(position, maxPosition);
      render();
    }
 
    function render() {
      track.style.transform =
        'translateX(-' + position * cardWidth + 'px)';
      prevBtn.disabled = position <= 0;
      nextBtn.disabled = position >= maxPosition;

      prevBtn.classList.toggle(
        'is-active',
        position > 0
      );

      nextBtn.classList.toggle(
        'is-active',
        position < maxPosition
      );
    }

    function goNext() {
      if (position >= maxPosition) {
        position = 0;
      } else {
        position += 1;
      }

      render();
    }

    function goPrev() {
      if (position <= 0) {
        position = maxPosition;
      } else {
        position -= 1;
      }

      render();
    }

    function manualNext() {
      if (position >= maxPosition) {
        return;
      }
      position += 1;
      render();
    }

    function manualPrev() {
      if (position <= 0) {
        return;
      }
      position -= 1;
      render();
    }

    prevBtn.addEventListener('click', function () {
      manualPrev();
      restartAutoplay();
    });

    nextBtn.addEventListener('click', function () {
      manualNext();
      restartAutoplay();
    });

    window.addEventListener('resize', measure);
 
    function restartAutoplay() {
      if (!config.autoplay) return;
      if (autoplayTimer) clearInterval(autoplayTimer);
      autoplayTimer = setInterval(goNext, config.autoplaySpeed || 5000);
    }
 
    fetch(buildRequestUrl(config))
      .then(function (res) {
        if (!res.ok) throw new Error('Yotpo request failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var reviews = normalizeReviews(data);
        loading.remove();
 
        if (!reviews.length) {
          track.innerHTML = '<p class="reviews-carousel__loading">No reviews yet.</p>';
          return;
        }
 
        reviews.forEach(function (review) {
          track.appendChild(buildCard(review));
        });
 
        var bottomline = normalizeBottomline(data);
        if (bottomline) {
          summaryStars.innerHTML = starString(bottomline.average);
          summaryCount.textContent = bottomline.total + '+ Reviews';
        } else {
          root.querySelector('.reviews-carousel__summary').remove();
        }
 
        measure();
        restartAutoplay();
        root.classList.remove('hidden');
      })
      .catch(function (err) {
        loading.textContent = 'Reviews could not be loaded right now.';
        console.error('[reviews-carousel]', err);
      });
  }
 
  document.addEventListener('DOMContentLoaded', function () {
    (window.reviewsCarouselSettings || []).forEach(function (config) {
      var root = document.querySelector(
        '.section-' + config.sectionId + ' [data-reviews-carousel], [data-reviews-carousel]'
      );
      if (!root || !config.appKey) return;
      initCarousel(root, config);
    });
  });
})();